// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"80758039b574235d","888":"d371b63fb50a5c0b"}[chunkId] + ".css";
};